function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 8.933c0 4.826 3.843 8.757 8.561 8.757h24.256c3.4 0 6.183-2.846 6.183-6.325 0-3.478-2.782-6.324-6.183-6.324H8.561c-2.083 0-3.805 1.761-3.805 3.892 0 2.13 1.722 3.892 3.805 3.892h20.927c.514.007.993-.27 1.252-.724.26-.454.26-1.017 0-1.471-.259-.455-.738-.731-1.252-.724H8.56c-.552 0-.951-.409-.951-.973 0-.564.4-.973.951-.973h24.256c1.87 0 3.33 1.494 3.33 3.405 0 1.912-1.46 3.406-3.33 3.406H8.561c-3.187 0-5.707-2.579-5.707-5.838 0-3.26 2.52-5.838 5.707-5.838h21.878c.515.008.993-.269 1.253-.724.259-.454.259-1.016 0-1.471-.26-.455-.738-.731-1.253-.724H8.561C3.843.176 0 4.107 0 8.933z"
});

var SvgPaperclip = function SvgPaperclip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 18,
    viewBox: "0 0 39 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperclip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paperclip.4110e480.svg";
export { ForwardRef as ReactComponent };